import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getGameList } from "@/api/game";
export default {
  name: "GameSelect",
  props: {
    'value': {
      default: 0
    },
    'data_no_all': {
      default: 1
    }
  },
  data: function data() {
    return {
      game_id: this.value,
      gameList: {}
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.game_id = val;
      }
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            data = {
              'data_no_all': _this.data_no_all
            };
            _context.next = 3;
            return getGameList(data);
          case 3:
            res = _context.sent;
            if (res.code == 0) {
              _this.gameList = res.data.games;
            }
            if (_this.game_id != '') {
              _this.selectGame();
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    selectGame: function selectGame() {
      this.$emit('input', this.game_id);
      this.$emit('change', this.game_id);
    }
  }
};